import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VProgressLinear,_vm._b({attrs:{"value":_vm.value,"color":_vm.color ? _vm.color : 'primary'},on:{"input":_vm.updateValue}},'v-progress-linear',_vm.$attrs,false),[_c('strong',{staticStyle:{"color":"#ffffff"}},[_vm._v(_vm._s(_vm.value)+"%")])])
}
var staticRenderFns = []

export { render, staticRenderFns }